import React, { useEffect } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import FormInput from '@/component/common/form/input';
import { MenuItem } from '@material-ui/core';
import { handleOnchangeFormDelegateAndTask } from './handler/DelegateTicketHandler';
import './TaskTicket.css';
import { getFormFromFormListById } from './handler/TicketHandler';

export default function TaskTicket(props) {

    useEffect(() => {
        props.registerCreateTicket('selectedForm');
        props.registerCreateTicket('fileUploadList');

        (async () => {
            props.setIsLoading(true);
            let userDetail = props.userDetail;
            let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
            let lastFormOfProject = workLastForm[props.projectInuseDetail.id];
            let switchFormId = props?.selectedForm ? props.selectedForm : '';
            if (lastFormOfProject) {
                let lastFormTaskOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_TASK];
                if (!Utils.isEmptyObject(lastFormTaskOfProject)) {
                    // Validate Form
                    let selectedFormDetail = await getFormFromFormListById(
                        lastFormTaskOfProject?.formId
                    );
                    let isLastFormNotValid = Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(props.projectInuseDetail.id);
                    
                    if (!isLastFormNotValid && !switchFormId) {
                        switchFormId = lastFormTaskOfProject?.formId;
                    }
                }
            }

            if (switchFormId) {
                let e = {
                    target: {
                        value: switchFormId
                    }
                }
                await handleOnchangeFormDelegateAndTask(e, {
                    ...props,
                    selectedForm: '',
                    typeOfTicket: Constant.TICKET_TYPE.TASK
                })
            }

            props.setIsLoading(false);
        })();
    }, []);

    return (
        <div>
            <div className="helpdesk-create-task-ticket form-addTicket-helpdesk-create">
                <div className="scrollBar-main">
                    <div className="addTicket">
                        <div className="form-addTicket">
                            <label className="form-addTicket-label">フォーマット</label>
                            <div className="form-addTicket-input">
                                <FormInput
                                    className="form-control form-control--wrap form-control--hg40"
                                    select
                                    variant="outlined"
                                    name="selectedForm"
                                    value={props.selectedForm ? props.selectedForm : ''}
                                    defaultValue={props.selectedForm ? props.selectedForm : ''}
                                    onClick={e => {
                                        handleOnchangeFormDelegateAndTask(e, {
                                            ...props,
                                            typeOfTicket: Constant.TICKET_TYPE.TASK
                                        });
                                        e.stopPropagation();
                                    }}
                                    required
                                    errorlist={props.errorCreateTicket}
                                    SelectProps={{
                                        value: props.selectedForm ? props.selectedForm : '',
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                        // open: isOpenSelectTicketType,
                                        // onClose: e => handleCloseSelectTicketType(argsAll),
                                        // onOpen: e => handleOpenSelectTicketType(argsAll)
                                    }}
                                    disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                                >
                                    {!Utils.isEmptyArray(props.formList) &&
                                        props.formList?.map(item => {
                                            return (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        item.name
                                                    )}
                                                </MenuItem>
                                            );
                                        })}
                                </FormInput>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
